import { call, put, takeLatest } from 'redux-saga/effects';

import { BenefitTemplateList } from '@models/BenefitTemplate';
import { BenefitTemplateApi } from '@apis/BenefitTemplateApi';

import {
  benefitTemplatesFetch,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleBenefitTemplatesFetch() {
  const state: StateUpdatePayload = { benefitTemplates: [] };
  try {
    state.benefitTemplates = (yield call(BenefitTemplateApi.getAll)) as BenefitTemplateList[];
    yield put(stateUpdate(state));
  } catch { }
}

export default function* () {
  yield takeLatest(benefitTemplatesFetch, handleBenefitTemplatesFetch);
}
